const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

// Mirrors YoutubeUrlValidator.video_id. Returns an 11-char id or null.
export default function youtubeVideoId(url) {
  const value = String(url ?? '').trim();
  let parsed;
  try {
    parsed = new URL(SCHEME.test(value) ? value : `https://${value}`);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(parsed.protocol)) {
    return null;
  }
  const host = parsed.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');
  let id = null;
  if (host === 'youtu.be') {
    id = parsed.pathname.match(/^\/([^/]+)/)?.[1] ?? null;
  } else if (host === 'youtube.com') {
    if (parsed.pathname === '/watch') {
      id = parsed.searchParams.get('v');
    } else {
      const match = parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/?]+)/);
      id = match ? match[1] : null;
    }
  }
  return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
}
